$(document).ready(function(){
  // Slider 
  $('.FT-SmrtScleSlider').slick({
    speed: 300,
    dots: true,
    arrows: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 789,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 579,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  // Scroll button for form
  $(document).on('click', '.Accodianjshandle', function(e){
    e.preventDefault();$(this).parents('.RferAfrnd-faqs-Items').toggleClass('Active');
    $(this).parents('.RferAfrnd-faqs-Items').children('.RferAfrnd-faqs_txt').slideToggle();
  });  
 document.querySelector(".ReferFRrnd_banner").addEventListener("click", function(event) { event.preventDefault(); 
    document.querySelector(".FT-ReferAFrndForm_WPR").scrollIntoView({ behavior: 'smooth' });
  });
  document.querySelector("[jsrefrformhndle]").addEventListener("click", function(event) { event.preventDefault();
    document.querySelector(".FT-ReferAFrndForm_WPR").scrollIntoView({ behavior: 'smooth' });
  });

}); 
